class PopupSection extends HTMLElement {
  constructor() {
    super();
    this.options = JSON.parse(this.dataset.sectionSettings);

    // Check if the popup should be displayed
    try {
      if (
        window.location.hash === "#newsletter-popup" &&
        window.theme?.pageType !== null
      ) {
        this.openPopup();
      } else if (
        !this.options.showOnlyOnce ||
        (this.options.showOnlyOnce &&
          localStorage.getItem("themePopup") === null)
      ) {
        setTimeout(() => {
          this.openPopup();
        }, this.options.apparitionDelay * 1000);
      }
    } catch (error) {
      console.error("Error with localStorage:", error);
    }

    this.attachListeners();
  }

  // connectedCallback() {
  //   this.options = JSON.parse(this.getAttribute("data-section-settings"));
  //   this.initPopup();

  //   if (this.dataset.slider == "true") {
  //     this.slides = this.querySelector(".hero-section__slides");
  //     this.controls = this.querySelector(".hero__dots");
  //     this.initFlickity();
  //   }
  // }
  initPopup() {}
  disconnectedCallback() {
    this.removeListeners();
  }

  attachListeners() {
    // Add event listener for the close button
    this.addEventListener("click", this.handleClick);
  }

  removeListeners() {
    // Remove the click event listener
    this.removeEventListener("click", this.handleClick);
  }

  handleClick = (event) => {
    const target = event.target;
    if (target.matches('[data-action="close-popup"]')) {
      this.closePopup();
    }
  };

  openPopup() {
    this.setAttribute("aria-hidden", "false");
    localStorage.setItem("themePopup", "true");

    document.addEventListener("click", ({ target }) => {
      const isClosest = target.closest(
        '[data-section-type="newsletter-popup"]'
      );
      // const popupSection = document.querySelector("popup-section");
      // console.log(isClosest)
      // console.log(popupSection.getAttribute("aria-hidden"))
      if (!isClosest && this.getAttribute("aria-hidden") == "false") {
        this.closePopup();
      }
    });
  }

  closePopup() {
    this.setAttribute("aria-hidden", "true");
  }

  initFlickity() {
    const dots = this.dataset.dots === "true" ? true : false;
    const arrows = this.dataset.arrows === "true" ? true : false;
    this.flickity = new Flickity(this.slides, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: arrows,
      arrowShape:
        "M38.39,17.65a3.91,3.91,0,0,0-1.12-1.51,3.83,3.83,0,0,0-1.69-.8A3.84,3.84,0,0,0,32.1,16.4L1.33,47.17a3.83,3.83,0,0,0-.83,4.2,3.85,3.85,0,0,0,.83,1.25L32.1,83.38a3.81,3.81,0,0,0,2.72,1.13,3.85,3.85,0,0,0,2.73-6.57L13.34,53.74h83a3.85,3.85,0,1,0,0-7.69h-83l24.21-24.2a3.8,3.8,0,0,0,1.05-2A3.86,3.86,0,0,0,38.39,17.65Z",
      pageDots: dots,
      wrapAround: true,
      cellAlign: "left",
      autoPlay:
        this.dataset.auto == "false" ? false : parseInt(this.dataset.auto),
      selectedAttraction: 0.02,
      friction: 0.25,
      adaptiveHeight: true,
      percentPosition: false,
      imagesLoaded: true,
    });

    window.onload = function () {
      window.dispatchEvent(new Event("resize"));
    };

    this.flickity.on(
      "staticClick",
      (_event, _pointer, _cellElement, cellIndex) => {
        if (typeof cellIndex == "number") {
          this.flickityControls.select(cellIndex);
        }
      }
    );

    this.flickityControls.on(
      "staticClick",
      (_event, _pointer, _cellElement, cellIndex) => {
        if (typeof cellIndex == "number") {
          this.flickity.select(cellIndex);
        }
      }
    );

    // Do stuff based on a successful swipe and its direction
    this.flickity.on("change", (index) => {
      this.flickityControls.select(index);
    });
  }
}
customElements.define("popup-section", PopupSection);

document.addEventListener("DOMContentLoaded", function (e) {});
// Add support for Shopify editor lifecycle events
document.addEventListener("shopify:section:load", (event) => {
  const sectionId = event.detail.sectionId;
  const section = document.getElementById(sectionId);
  if (section && section.tagName.toLowerCase() === "popup-section") {
    console.log("Newsletter popup section loaded:", sectionId);
  }
});

document.addEventListener("shopify:section:unload", (event) => {
  const sectionId = event.detail.sectionId;
  const section = document.getElementById(sectionId);
  if (section && section.tagName.toLowerCase() === "popup-section") {
    console.log("Newsletter popup section unloaded:", sectionId);
  }
});
